import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./table.module.css";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { CiFilter } from "react-icons/ci";
import { useLocation, useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const TableHead = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setsearchParams] = useSearchParams();
  const [dropdownVisibility, setDropdownVisibility] = useState({});

  const [selectedFilter, setSelectedFilter] = useState({
    Category: [],
    Collection: [],
  });

  useEffect(() => {
    const restoredData = RestoreFilterData();

    setSelectedFilter({ ...restoredData });
  }, []);

  const searchPar = new URLSearchParams(location.search);

  const RestoreFilterData = () => {
    const paramsObject = {};
    for (const [key, value] of searchPar.entries()) {
      // If the key already exists, convert it to an array
      if (paramsObject.hasOwnProperty(key)) {
        if (!Array.isArray(paramsObject[key])) {
          console.log(paramsObject[key]);
          paramsObject[key] = [paramsObject[key]];
        }
        paramsObject[key].push(value);
      } else {
        paramsObject[key] = [value];
      }
    }
    return paramsObject;
  };

  const handleFilterDropDown = (filterTitle) => {
    // Toggle the visibility of the dropdown for the clicked filter
    setDropdownVisibility((prevVisibility) => ({
      ...Object.fromEntries(
        Object.keys(prevVisibility).map((key) => [key, false])
      ),
      [filterTitle]: !prevVisibility[filterTitle],
    }));
  };

  const handleFilter = (e, title, value) => {
    // console.log(selectedFilter);
    // console.log(e.target.checked, title, value);
    if (e.target.checked) {
      let temp = selectedFilter[title] ? [...selectedFilter[title]] : [];
      temp.push(value);
      setSelectedFilter({ ...selectedFilter, [title]: temp });
    } else {
      let dump = [...selectedFilter[title]];
      dump.splice(selectedFilter[title].indexOf(value), 1);
      setSelectedFilter({ ...selectedFilter, [title]: dump });
    }
  };

  const constructSearchQuery = (updatedFilter) => {
    console.log(updatedFilter);
    if (updatedFilter) setSelectedFilter({ ...updatedFilter });

    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    // console.log(url);
    url.search = "";

    // Add selected filters as search parameters
    Object.entries(selectedFilter).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          url.searchParams.append(key, val);
        });
      } else {
        // @ts-ignore
        url.searchParams.append(key, value);
      }
      // console.log(url);
      navigate(`${url.search}`, { replace: true });
    });

    return url.href;
  };

  const handleApply = (updatedFilter) => {
    constructSearchQuery();
  };

  const clearAll = (val) => {
    console.log("Before State Update:", selectedFilter);
    setSelectedFilter((prevSelectedFilter) => {
      Object.entries(prevSelectedFilter).forEach(([key, value]) => {
        prevSelectedFilter[key] = [];
      });
      return { ...prevSelectedFilter };
    });

    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.search = "";
    navigate(`${url.search}`, { replace: true });
  };

  return (
    <thead
      style={{
        zIndex: 100,
        position: "sticky",
        top: 0,
        background: "rgb(218,228,245)",
      }}
    >
      <tr>
        {props.head.map((val, index) => {
          return (
            <>
              {val.title === "_select" ? (
                <th
                  align="left"
                  key={index}
                  style={{ width: "50px", textAlign: "left" }}
                >
                  <input type="checkbox" />
                </th>
              ) : (
                <th
                  align="left"
                  key={index}
                  style={
                    val?.filter
                      ? {
                          cursor: "pointer",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (val.title === props?.showIconAt) {
                      props.onHeadClick();
                    }
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                    }}
                  >
                    <p>{val.title}</p>
                    {val.title === props?.showIconAt && props?.icon}
                    {val?.filter && (
                      <>
                        {searchParams?.get(val?.value) ? (
                          <FontAwesomeIcon
                            icon={faFilter}
                            color="grey"
                            onClick={() => handleFilterDropDown(val.value)}
                          />
                        ) : (
                          <CiFilter
                            size={16}
                            color={"grey"}
                            onClick={() => handleFilterDropDown(val.value)}
                          />
                        )}
                      </>
                    )}
                  </div>
                  {dropdownVisibility[val.value] && (
                    <div className={styles.dropdown}>
                      {props.filtervalue[val.value]?.map((value, ind) => (
                        <div className={styles.drop_val}>
                          <input
                            type="checkbox"
                            name=""
                            id=""
                            onClick={(e) => handleFilter(e, val.value, value)}
                            checked={
                              selectedFilter[val?.value]?.includes(value)
                                ? true
                                : false
                            }
                          />
                          <p key={ind}>{value}</p>
                        </div>
                      ))}
                      <div className={styles.dropdown_btn}>
                        <button onClick={handleApply}>APPLY</button>
                        <button onClick={() => clearAll(val.value)}>
                          CLEAR ALL
                        </button>
                      </div>
                    </div>
                  )}
                </th>
              )}
            </>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHead;
